// extracted by mini-css-extract-plugin
module.exports = {"About":"About_About__3gGxb","Background":"About_Background__15RKc","Wrapper":"About_Wrapper__1iY5n","Info":"About_Info__3Orr_","Bio":"About_Bio__2Jbve"};